
<template>
  <div>
    <div class="common-form">考核设置</div>
    <el-form-item label="考核方式" prop="is_examine">
      <el-radio-group v-model="form.waiter.isExamine" class="max-w460">
        <el-radio :label="1">自动考核</el-radio>
        <el-radio :label="2">手动考核</el-radio>
      </el-radio-group>
      <div style="color:#ff6f06; display:flex; flex-direction: column;line-height:20px;font-weight:700">
        <span>温馨提示：</span>
        <span> 自动考核开启：则按照技师考核规则进行升级变更 (每月一号进行考核)</span>
        <span>手动考核开启：则执行技师单独佣金比例(如单独比例没有设置，则获取系统技师默认比例进行分成)</span>
      </div>
    </el-form-item>

    <el-form-item label="分成比例：">
      <el-input placeholder="请输入内容" v-model="form.waiter.scale" class="max-w460">
        <template slot="prepend">比例</template>
        <template slot="append">%</template>
      </el-input>
      <div v-if="form.message" style="color:#ff6f06; display:flex;line-height:20px;font-weight:700">
        温馨提示：
        <span>{{form.message}}</span>
      </div>
    </el-form-item>
    <el-form-item label="">

    </el-form-item>

  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  inject: ["form"],
  mounted() {},
  computed: {},
  methods: {}
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/technician/technicianlist/part/setscale.vue